export enum ID_TYPE {
    guest = 2,
    office = 3,
    citizen = 1
}